import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { environment} from '../../environments/environment';
import { log } from 'console';

@Injectable()
export class OffboardingService {

  headers;
  constructor(
    private http: HttpClient) {}

    /* Getting Headers */
    getHeaders() {
      this.headers = new HttpHeaders({
        "Content-Type": "application/json",
        Accept: "application/json",
        "access-token": localStorage.getItem("access-token"),
        client: localStorage.getItem("client"),
        clientid: localStorage.getItem("client_id"),
        expiry: localStorage.getItem("expiry"),
        uid: localStorage.getItem("uid"),
      });
      this.headers["key"] = "key";      
    }


    getOffboardingList(pgNo:number):Observable<any>{
      this.getHeaders();
      let query = '/offboarding_list'+'?page=' + pgNo;

      return this.http.get(environment.offboarding_url + query, {headers: this.headers,  observe: 'response'} );
    }

    addOffboarding(id:number):Observable<any>{
      this.getHeaders();
      let query = '/initiate_offboarding/'+id;
      
      return this.http.post(environment.offboarding_url + query, {}, {headers: this.headers} );
    }

    getOffboardingEmployeeDetails(id:string):Observable<any>{
      this.getHeaders();
      const query = `/offboarding_employee_detatails/${id}`;
      
      return this.http.get(environment.offboarding_url + query, {headers: this.headers,  observe: 'response'} );
    }
}



// WEBPACK FOOTER //
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/services/offboarding.service.ts